import React from 'react';
import { Form, Input, InputNumber, Select } from 'antd';
import { FieldDef } from '../../api/productTypeCatalog';

export const BASE_TYPES = [
  { value: 'synthetic', label: 'Синтетика' },
  { value: 'semi_synthetic', label: 'Полусинтетика' },
  { value: 'mineral', label: 'Минеральное' },
];

export const baseTypeMap = Object.fromEntries(BASE_TYPES.map(t => [t.value, t.label]));

const STANDARD_KEYS = new Set(['viscosity', 'base_type', 'specifications']);

export const TypeFieldsFormItems: React.FC<{ fields: FieldDef[] }> = ({ fields }) => (
  <>
    {fields.map(field => {
      const isStandard = STANDARD_KEYS.has(field.key);
      const formName = isStandard ? field.key : ['extra_data', field.key];

      if (field.key === 'base_type') {
        return (
          <Form.Item key={field.key} name="base_type" label={field.label}>
            <Select
              options={BASE_TYPES}
              allowClear
              placeholder={field.placeholder || 'Выберите тип базы'}
            />
          </Form.Item>
        );
      }
      if (field.key === 'specifications' || field.field_type === 'tags') {
        return (
          <Form.Item key={field.key} name={formName} label={field.label}>
            <Select mode="tags" placeholder={field.placeholder || 'Введите и нажмите Enter'} />
          </Form.Item>
        );
      }
      if (field.field_type === 'select') {
        return (
          <Form.Item key={field.key} name={formName} label={field.label}>
            <Select
              options={field.options.map(o => ({ value: o, label: o }))}
              allowClear
              placeholder={field.placeholder}
            />
          </Form.Item>
        );
      }
      if (field.field_type === 'number') {
        return (
          <Form.Item key={field.key} name={formName} label={field.label}>
            <InputNumber placeholder={field.placeholder} style={{ width: '100%' }} />
          </Form.Item>
        );
      }
      return (
        <Form.Item key={field.key} name={formName} label={field.label}>
          <Input placeholder={field.placeholder} />
        </Form.Item>
      );
    })}
  </>
);
